var render = function (_h,_vm) {var _c=_vm._c;return _c('v-btn',{staticClass:"c-base-button",attrs:{"rounded":"","depressed":_vm.props.depressed,"small":"","disabled":_vm.props.disabled,"color":_vm.props.color},on:{"click":_vm.listeners.click}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }